var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apex-chart',{attrs:{"type":"pie","series":_vm.series,"options":_vm.chartOptions,"height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }